// hundredContractConfig.js

// Import the ABI from a JSON file (assuming the ABI file is located in the 'abis' directory)
import hundredContractABI from '../abi/hundredContractABI.json';

// Define the contract address (replace '0x123...' with your contract's actual address)
export const hundredContractAddress = '0x4586AF10ecceeD4E383e3f2Ec93b6C61e26500b5';

// Export the ABI
export const hundredAbi = hundredContractABI;